import TomSelect from 'tom-select'

$(document).ready(() => {
  console.log('=== BOOKINGS.JS READY HANDLER RUNNING ===');
  
  window.showDesc = (slug) => {
    const x = $('#desc_' + slug)
    if (x.is(':visible') == false) {
      $('#desc_' + slug).show()
    } else {
      $('#desc_' + slug).hide()
    }
  }

  if ($('.tom-select').length > 0) {
    $('.tom-select').each((index, elem) => {
      const elemId = elem.id
      let tomSelectParams = {
        copyClassesToDropdown: true,
        onInitialize: function () {
          this.wrapper.classList.add('ds-select');
          this.wrapper.classList.add('ds-select--combo');
          this.control.classList.add('ds-select');
          this.dropdown.classList.add('ds-select');
          const hostWrapper = this.input.parentElement;
          if (hostWrapper && hostWrapper.classList.contains('ds-select-wrapper')) {
            hostWrapper.classList.add('ds-select-wrapper--enhanced');
          }
        }
      }

      if ($(elem).data('tom-select-search') != true) {
        tomSelectParams['controlInput'] = null
      }

      if (elemId == 'location_setter') {
        tomSelectParams['items'] = elem.getAttribute('data-location')
        tomSelectParams['render'] = {
          option: function (data, escape) {
            if (data.src === undefined) {
              return `<div>${data.text}</div>`
            } else {
              return `<div><img class="me-2" src="${data.src}">${data.text}</div>`
            }
          },
          item: function (item, escape) {
            if (item.src === undefined) {
              return `<div>${item.text}</div>`
            } else {
              return `<div><img class="me-2" src="${item.src}">${item.text}</div>`
            }
          }
        }
      } else if (elemId == 'quote_location' || elemId == 'gratuity_setter') {
        tomSelectParams['allowEmptyOption'] = true
      }
      
      new TomSelect(`#${elemId}`, tomSelectParams)
    })
  }

  $('#copyboard').on('click', function (e) {
    e.preventDefault()
    const copyText = $(this).attr('data-text')
    const textarea = document.createElement('textarea')
    textarea.textContent = copyText
    textarea.style.position = 'fixed'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    $('#share-link-copied').removeClass('d-none')
  })

  // Initialize gratuity form if present
  const gratuityField = $('#gratuity_amount')
  console.log('Checking for gratuity form - field length:', gratuityField.length);
  
  if (gratuityField.length > 0) {
    console.log('Gratuity form detected, initializing...')
    // Expose function to window immediately
    window.initializeGratuityFormNow = initializeGratuityForm;
    // Wait a bit for everything to be ready
    setTimeout(function() {
      console.log('Calling initializeGratuityForm from setTimeout...');
      initializeGratuityForm()
    }, 500)
  } else {
    console.log('No gratuity form found on this page')
  }
})

window.initializeGratuityForm = function() {
  console.log('=== Initializing gratuity form ===')
  
  const subtotalElement = document.querySelector('[data-subtotal]')
  if (!subtotalElement) {
    console.error('No subtotal element found')
    return
  }
  
  const subtotal = parseFloat(subtotalElement.dataset.subtotal)
  console.log('Subtotal from data attribute:', subtotal)
  
  if (isNaN(subtotal) || subtotal <= 0) {
    console.error('Invalid subtotal:', subtotal)
    return
  }
  
  // Get all required form elements
  const gratuityAmountField = document.getElementById('gratuity_amount')
  const gratuityDisplay = document.getElementById('gratuity_display')
  const customGratuityInput = document.getElementById('custom_gratuity')
  const submitButton = document.getElementById('submit-gratuity')
  const errorElement = document.getElementById('card-errors')
  const errorDiv = document.getElementById('card-error-message')
  
  if (!gratuityAmountField || !gratuityDisplay || !customGratuityInput || !submitButton) {
    console.error('Missing required form elements')
    console.log('gratuityAmountField:', gratuityAmountField)
    console.log('gratuityDisplay:', gratuityDisplay)
    console.log('customGratuityInput:', customGratuityInput)
    console.log('submitButton:', submitButton)
    return
  }
  
  console.log('All form elements found')
  
  let selectedPercentage = null
  let cardComplete = false
  
  // Check if Stripe is loaded
  if (typeof Stripe === 'undefined') {
    console.error('Stripe is not loaded!')
    return
  }
  
  // Get Stripe key from element
  const stripeKeyElement = document.querySelector('[data-stripe-key]')
  if (!stripeKeyElement) {
    console.error('No Stripe key element found')
    return
  }
  
  const stripe = Stripe(stripeKeyElement.dataset.stripeKey)
  console.log('Stripe initialized')
  
  const elements = stripe.elements()
  
  // Style for Stripe elements
  const style = {
    base: {
      fontSize: '16px',
      color: '#1f2937',
      '::placeholder': {
        color: '#9ca3af'
      }
    },
    invalid: {
      color: '#ef4444'
    }
  }
  
  // Create card elements
  const cardNumber = elements.create('cardNumber', { style: style, showIcon: true })
  const cardExpiry = elements.create('cardExpiry', { style: style })
  const cardCvc = elements.create('cardCvc', { style: style })
  const postalCode = elements.create('postalCode', { style: style })
  
  // Mount elements
  console.log('Mounting Stripe elements...')
  cardNumber.mount('#card-number')
  cardExpiry.mount('#card-expiry')
  cardCvc.mount('#card-cvc')
  postalCode.mount('#card-postal')
  console.log('Stripe elements mounted')
  
  // Update submit button state
  function updateSubmitButton() {
    const gratuityAmount = parseFloat(gratuityAmountField.value) || 0
    const canSubmit = cardComplete && gratuityAmount > 0
    submitButton.disabled = !canSubmit
    console.log('Submit button state - amount:', gratuityAmount, 'cardComplete:', cardComplete, 'canSubmit:', canSubmit)
  }
  
  // Handle card element changes
  function handleElementChange(event) {
    if (event.error) {
      errorElement.classList.remove('d-none')
      errorElement.style.display = ''
      errorDiv.textContent = event.error.message
      cardComplete = false
    } else {
      errorElement.classList.add('d-none')
      errorElement.style.display = 'none'
      errorDiv.textContent = ''
      cardComplete = event.complete || false
    }
    updateSubmitButton()
  }
  
  cardNumber.on('change', handleElementChange)
  cardExpiry.on('change', handleElementChange)
  cardCvc.on('change', handleElementChange)
  postalCode.on('change', handleElementChange)
  
  // Handle percentage button clicks
  console.log('Setting up percentage buttons...')
  const percentageButtons = document.querySelectorAll('.ds-gratuity-button')
  console.log('Found ' + percentageButtons.length + ' percentage buttons')
  
  percentageButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault()
      e.stopPropagation()
      console.log('Percentage button clicked:', this.dataset.percentage)
      
      const percentage = parseInt(this.dataset.percentage)
      selectedPercentage = percentage
      
      // Update active state
      document.querySelectorAll('.ds-gratuity-button').forEach(btn => {
        btn.classList.remove('active')
      })
      this.classList.add('active')
      
      // Calculate gratuity
      const gratuityAmount = Math.round(subtotal * percentage) / 100
      console.log('Calculated gratuity:', gratuityAmount)
      
      // Update fields
      gratuityAmountField.value = gratuityAmount.toFixed(2)
      gratuityDisplay.textContent = '$' + gratuityAmount.toFixed(2)
      customGratuityInput.value = ''

      // Pulse the recomputed amount so the change registers. Presets only —
      // flashing on every custom-input keystroke would be noise.
      gratuityDisplay.classList.remove('ds-price-flash')
      void gratuityDisplay.offsetWidth
      gratuityDisplay.classList.add('ds-price-flash')

      updateSubmitButton()
    })
  })
  
  // Handle custom amount input
  console.log('Setting up custom input...')
  customGratuityInput.addEventListener('input', function() {
    const customAmount = parseFloat(this.value) || 0
    console.log('Custom amount entered:', customAmount)
    
    // Clear percentage selection
    document.querySelectorAll('.ds-gratuity-button').forEach(btn => {
      btn.classList.remove('active')
    })
    selectedPercentage = null
    
    // Update fields
    gratuityAmountField.value = customAmount.toFixed(2)
    gratuityDisplay.textContent = '$' + customAmount.toFixed(2)
    
    updateSubmitButton()
  })
  
  // Handle form submission
  const form = document.getElementById('gratuity-form')
  form.addEventListener('submit', function(event) {
    event.preventDefault()
    
    submitButton.disabled = true
    submitButton.innerHTML = '<span class="ds-btn-spinner" aria-hidden="true"></span> <span>Processing...</span>'
    
    stripe.createToken(cardNumber).then(function(result) {
      if (result.error) {
        errorElement.classList.remove('d-none')
        errorElement.style.display = ''
        errorDiv.textContent = result.error.message
        submitButton.disabled = false
        submitButton.innerHTML = '<span class="ds-btn__icon"><i data-lucide="heart" class="lucide-icon" aria-hidden="true"></i></span><span>Process Gratuity Payment</span>'
        // Reinitialize Lucide icons
        if (typeof lucide !== 'undefined') {
          lucide.createIcons()
        }
        return
      }
      
      // Clear errors
      errorElement.classList.add('d-none')
      errorElement.style.display = 'none'
      errorDiv.textContent = ''
      
      // Add token to form
      const tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'stripeToken'
      tokenInput.value = result.token.id
      form.appendChild(tokenInput)
      
      form.submit()
    })
  })
  
  console.log('Gratuity form initialization complete')
}
